import {
  FETCH_KIOSK_SETTINGS,
  FETCH_KIOSK_USER,
  FETCH_KIOSK_JOBS,
  FETCH_KIOSK_MOMENTS,
  FETCH_KIOSK_SELECTED_JOB,
  FETCH_KIOSK_SELECTIONS,
  FETCH_KIOSK_EMAIL,
  FETCH_ROOM_MOMENTS,
  FETCH_GUESTS,
  FETCH_PORTAL_MOMENTS,
  SELECT_KIOSK_MOMENTS,
  UNSELECT_KIOSK_MOMENTS,
  VIEW_CATALOG,
  VIEW_GALLERY,
  VIEW_CART,
  VIEW_PRE_PRINT,
  VIEW_RECEIPT,
  KIOSK_LOADED,
  SET_CURRENT_DATE,
  SET_DATES,
  FETCH_FAMILY,
  FETCH_VISITS,
  FETCH_VISIT,
  REMOVE_VISIT,
  FETCH_MERGED_STORIES,
  ADD_MERGED_STORY,
  SELECT_LOCALE,
  SET_SCROLL_POSITION,
  GET_KIOSK_PRINT_SIZES,
  SELECT_PRE_PRINTS,
  UNSELECT_PRE_PRINTS,
  CLEAR_PRE_PRINTS,
  GET_KNOCKOUT_ELEMENTS,
  GET_STRIPE_READERS,
  SET_DEFAULT_KIOSK_READER,
  VIEW_VIDEO,
  VALIDATE_KNOCKOUT_ELEMENTS,
  CHECK_EXISTING_EDITS,
  SELECT_PRINT_SIZE_FOR_CROP,
  TIMEOUT_DIALOG_OPEN,
  FETCH_MOMENT_COUNT
} from 'app/actions/types';

import {
  LOGOUT,
  NEW_ORDER,
  REMOVE_CART_MOMENT,
  GET_KIOSK_PRICINGS
} from 'shared/actions/types';

import KioskService from 'app/services/KioskService';
import UserService from 'shared/services/UserService';
import { getKioskPricings as getKioskPricingSvc } from 'shared/services/PriceService';
import {
  getMomentAssetSignedUrl as getMomentAssetSignedUrlSvc,
  uploadFile as uploadFileSvc,
  processThumbnails as processThumbnailsSvc
} from 'shared/services/FileService';

// disabling Braze
//import { Braze, onBrazeInit } from 'shared/services/Braze';

import {
  getStore
} from 'shared/services/Store';

const service = new UserService();
const isViewPhotosItem = localStorage.getItem('VIEW_PHOTOS');
const isViewPhotos = isViewPhotosItem === 'false' || !isViewPhotosItem ? false : true;

export const processThumbnails = (momentId, editSource, printSize) => async dispatch => {
  return await processThumbnailsSvc(momentId, editSource, printSize);
}

export const backupMoment = (momentId) => async dispatch => {
  return await KioskService.backupMoment(momentId);
}

export const uploadMoment = (momentId, type, file, editSource, printSize) => async dispatch => {
  var signed = await getMomentAssetSignedUrlSvc(momentId, type, true, editSource, printSize);
  return await uploadFileSvc(signed.url, file);
}

export const setKioskLoaded = () => dispatch => {
  dispatch({
    type: KIOSK_LOADED
  });

  return Promise.resolve();
}

export const getKioskSettings = token => dispatch => {
  return KioskService.getSettings(token)
    .then(settings => {
      dispatch({
        type: FETCH_KIOSK_SETTINGS,
        payload: settings
      });

      return Promise.resolve(settings);
    });
}

export const me = token => dispatch => {
  if (isViewPhotos) {
    return service.me().then((user) => {
      let locale = user.locale;

      if (locale) {
        dispatch({
          type: SELECT_LOCALE,
          payload: locale
        });
      }

      dispatch({
        type: FETCH_KIOSK_USER,
        payload: { user }
      });

      return Promise.resolve(user);
    })
  } else {
    return KioskService.me(token)
      .then(user => {
        // disabling Braze
        //initBraze(user);

        let locale = user.locale;

        if (locale) {
          dispatch({
            type: SELECT_LOCALE,
            payload: locale
          });
        }

        dispatch({
          type: FETCH_KIOSK_USER,
          payload: { user }
        });

        return Promise.resolve(user);
      });
  }
}

export const login = (token, params) => dispatch => {
  if (isViewPhotos) {
    return service.signInWithCredentials(params.email, params.password).then((user) => {

      dispatch({
        type: FETCH_KIOSK_USER,
        payload: { user, VIEW_PRE_PRINT, isViewPhotos }
      });

      return Promise.resolve(user);

    })
  } else {
    return KioskService.login(token, params)
      .then(user => {
        // disabling Braze
        //initBraze(user);

        let { jobs } = getStore();
        let jobsExist = jobs.allIds.length;
        let view = jobsExist ? VIEW_CATALOG : VIEW_GALLERY;

        dispatch({
          type: FETCH_KIOSK_USER,
          payload: { user, view }
        });

        return Promise.resolve(user);
      });
  }
}

export const logout = () => dispatch => {
  return KioskService.logout()
    .then(() => {
      dispatch({
        type: LOGOUT
      });

      return Promise.resolve();
    });
}

export const getJobs = token => dispatch => {
  return KioskService.getJobs(token)
    .then(jobs => {
      dispatch({
        type: FETCH_KIOSK_JOBS,
        payload: jobs
      });

      return Promise.resolve(jobs);
    });
}

export const getMoments = (token, jobId, page, perPage) => dispatch => {
  return KioskService.getMoments(token, jobId, page, perPage)
    .then(moments => {
      dispatch({
        type: FETCH_KIOSK_MOMENTS,
        payload: { jobId, moments }
      });

      return Promise.resolve(moments);
    });
}

export const getRoomMoments = (token, storyId, page, perPage) => dispatch => {
  return KioskService.getRoomMoments(token, storyId, page, perPage)
    .then(moments => {
      dispatch({
        type: FETCH_ROOM_MOMENTS,
        payload: moments
      });

      return Promise.resolve(moments);
    });
}

export const selectJob = jobId => dispatch => {
  dispatch({
    type: FETCH_KIOSK_SELECTED_JOB,
    payload: jobId
  });

  return Promise.resolve();
}

export const getSelections = (token, storyId) => dispatch => {
  return KioskService.getSelections(token, storyId)
    .then(selections => {
      // Updating selections in both cart and kioskReducer
      let momentIds = selections.map(s => s.moment_id);

      dispatch({
        type: FETCH_KIOSK_SELECTIONS,
        payload: momentIds
      });

      return Promise.resolve(selections);
    });
}

export const saveSelections = (token, storyId, momentIds) => dispatch => {
  return KioskService.selectMoments(token, storyId, momentIds);
}

export const saveUnselection = (token, storyId, momentId) => dispatch => {
  return KioskService.unselectMoment(token, storyId, momentId)
    .then(selections => {
      dispatch({
        type: REMOVE_CART_MOMENT,
        payload: momentId
      });

      dispatch({
        type: UNSELECT_KIOSK_MOMENTS,
        payload: [momentId]
      });

      return Promise.resolve(selections);
    });
}

export const selectMoments = (token, storyId, momentIds) => dispatch => {
  return KioskService.selectMoments(token, storyId, momentIds)
    .then(() => {

      dispatch({
        type: SELECT_KIOSK_MOMENTS,
        payload: momentIds
      });

      return Promise.resolve();
    });
}

export const unselectMoment = (token, storyId, momentId) => dispatch => {
  return KioskService.unselectMoment(token, storyId, momentId)
    .then(() => {
      dispatch({
        type: REMOVE_CART_MOMENT,
        payload: momentId
      });

      dispatch({
        type: UNSELECT_KIOSK_MOMENTS,
        payload: [momentId]
      });

      return Promise.resolve();
    });
}

const fetchEmail = (dispatch, email) => {
  dispatch({
    type: FETCH_KIOSK_EMAIL,
    payload: email
  });
}

export const setEmail = email => dispatch => {
  fetchEmail(dispatch, email);
  return Promise.resolve();
}

export const sendEmail = (customerId, email) => dispatch => {
  fetchEmail(dispatch, email);

  let params = {
    email: email,
    notify: true
  }

  return KioskService.updateCustomer(customerId, params);
}

export const setCurrentDate = date => dispatch => {
  dispatch({
    type: SET_CURRENT_DATE,
    payload: date
  });

  return Promise.resolve();
}

export const setDates = dates => dispatch => {
  dispatch({
    type: SET_DATES,
    payload: dates
  });

  return Promise.resolve();
}

export const viewCatalog = () => dispatch => {
  dispatch({
    type: VIEW_CATALOG
  });

  // hotfix scrollbar for web cart iframe
  document.body.style.overflowY = 'scroll';

  return Promise.resolve();
}

export const viewGallery = () => dispatch => {
  dispatch({
    type: VIEW_GALLERY
  });

  // hotfix scrollbar for web cart iframe
  document.body.style.overflowY = 'scroll';

  return Promise.resolve();
}

export const viewPrePrint = () => dispatch => {
  dispatch({
    type: VIEW_PRE_PRINT
  });

  // hotfix scrollbar for web cart iframe
  document.body.style.overflowY = 'scroll';

  return Promise.resolve();
}

export const viewCart = () => dispatch => {
  dispatch({
    type: VIEW_CART
  });

  // hotfix scrollbar for web cart iframe
  document.body.style.overflowY = 'scroll';

  return Promise.resolve();
}

export const viewReceipt = () => dispatch => {
  dispatch({
    type: VIEW_RECEIPT
  });

  return Promise.resolve();
}

export const getGuests = (token, storyId) => dispatch => {
  return KioskService.getGuests(token, storyId)
    .then(guests => {
      dispatch({
        type: FETCH_GUESTS,
        payload: guests
      });

      return Promise.resolve(guests);
    });
}

export const newOrder = () => dispatch => {
  dispatch({ type: NEW_ORDER });
  return Promise.resolve();
}

export const createFamily = (token, storyId) => dispatch => {
  return KioskService.createFamily(token, storyId)
    .then(family => {
      dispatch({
        type: FETCH_FAMILY,
        payload: family
      });

      return Promise.resolve(family);
    });
}

export const getVisits = (token, familyId) => dispatch => {
  return KioskService.getVisits(token, familyId)
    .then(visits => {
      dispatch({
        type: FETCH_VISITS,
        payload: visits
      });

      return Promise.resolve(visits);
    });
}

export const setVisit = visit => dispatch => {
  dispatch({
    type: FETCH_VISIT,
    payload: visit
  });

  return Promise.resolve();
}

export const addVisit = (token, familyId, visit) => dispatch => {
  return KioskService.addVisit(token, familyId, visit.id)
    .then(visit => {
      dispatch({
        type: FETCH_VISIT,
        payload: visit
      });

      return Promise.resolve(visit);
    });
}

export const removeVisit = (token, familyId, visit) => dispatch => {
  return KioskService.removeVisit(token, familyId, visit.id)
    .then(() => {
      dispatch({
        type: REMOVE_VISIT,
        payload: visit
      });
    });
}

export const searchVisits = (token, room) => () => {
  return KioskService.searchVisits(token, room);
}

export const searchCustomers = (token, customerId, search) => () => {
  return KioskService.searchCustomers(token, customerId, search);
}

export const fetchMergedStories = (token, storyId) => dispatch => {
  return KioskService.fetchMergedStories(token, storyId)
    .then(mergedStories => {
      dispatch({
        type: FETCH_MERGED_STORIES,
        payload: mergedStories
      });

      return Promise.resolve(mergedStories);
    });
}

export const addMergedStory = (token, targetStoryId, sourceStoryId) => dispatch => {
  return KioskService.addMergedStory(token, targetStoryId, sourceStoryId)
    .then(mergedStory => {
      dispatch({
        type: ADD_MERGED_STORY,
        payload: mergedStory
      });

      return Promise.resolve(mergedStory);
    });
}

export const authorizePin = (accountId, pin) => () => {
  return KioskService.authorizePin(accountId, pin);
}

export const updateKioskReader = (token, params) => () => {
  return KioskService.updateKioskReader(token, params);
}

export const setScrollPosition = position => dispatch => {
  dispatch({
    type: SET_SCROLL_POSITION,
    payload: position
  });
}

export const getKioskPrintSizes = kioskId => dispatch => {
  return KioskService.getKioskPrintSizes(kioskId).then((result) => {
    dispatch({
      type: GET_KIOSK_PRINT_SIZES,
      payload: result
    });
  })
}

export const getKioskPricings = kioskId => dispatch => {
  return getKioskPricingSvc(kioskId).then((result) => {
    dispatch({
      type: GET_KIOSK_PRICINGS,
      payload: result
    })
  })
}

export const getMomentsV2 = (page, perPage, filterModel, sortModel, currMoments, isCountQuery = false) => async dispatch => {
  let params = {
    page,
    per_page: perPage,
    filter_model: filterModel,
    sort_model: sortModel,
    is_count_query: isCountQuery
  }

  if (isCountQuery) {
    KioskService.getPortalMomentCount(params).then(count => {
      dispatch({
        type: FETCH_MOMENT_COUNT,
        payload: count
      })
    })
  }

  return KioskService.getPortalMoments(params, currMoments)
    .then(moments => {
      if (moments) {
        if (currMoments) {
          moments = moments.concat(currMoments);
        }
        dispatch({
          type: FETCH_PORTAL_MOMENTS,
          payload: moments
        });
      }

      return Promise.resolve(moments);
    });
}

export const selectPrePrints = momentIds => dispatch => {
  dispatch({
    type: SELECT_PRE_PRINTS,
    payload: momentIds
  });

  return Promise.resolve();
}

export const unSelectPrePrints = momentIds => dispatch => {
  dispatch({
    type: UNSELECT_PRE_PRINTS,
    payload: momentIds
  });

  return Promise.resolve();
}

export const clearPrePrints = () => dispatch => {
  dispatch({
    type: CLEAR_PRE_PRINTS
  });

  return Promise.resolve();
}

export const getKnockOutElements = (momentId, printSize) => dispatch => {
  return KioskService.getKnockoutElements(momentId, printSize)
    .then(elements => {
      if (elements) {
        dispatch({
          type: GET_KNOCKOUT_ELEMENTS,
          payload: elements
        });
        return Promise.resolve(elements);
      }
    }).catch(() => {
      dispatch({
        type: GET_KNOCKOUT_ELEMENTS,
        payload: {}
      });
    });
}

export const getStripeReaders = (token) => dispatch => {
  return KioskService.getStripeReaders(token).then((readers) => {
    dispatch({
      type: GET_STRIPE_READERS,
      payload: readers
    })
    return Promise.resolve(readers);
  })
}

export const getDefaultStripeReader = () => dispatch => {
  const strReader = localStorage.getItem('defaultStripeReader');
  if (!strReader) {
    return null;
  }
  const objReader = JSON.parse(strReader);
  dispatch({
    type: SET_DEFAULT_KIOSK_READER,
    payload: objReader
  })
}

export const setDefaultStripeReader = (reader) => dispatch => {
  localStorage.setItem('defaultStripeReader', JSON.stringify(reader));
  dispatch({
    type: SET_DEFAULT_KIOSK_READER,
    payload: reader
  })
  return Promise.resolve(reader);
}

export const viewVideo = (open, videoMoment) => dispatch => {
  dispatch({
    type: VIEW_VIDEO,
    payload: { visible: open, videoMoment }
  })
  return Promise.resolve(videoMoment);
}

export const validateKnockoutElements = (momentId, printSizeString) => async dispatch => {
  return await KioskService.validateKnockoutElements(momentId, printSizeString).then((elements) => {
    dispatch({
      type: VALIDATE_KNOCKOUT_ELEMENTS,
      payload: elements
    })
    return Promise.resolve(elements);
  })
}

export const selectPrintSizeForCrop = (printSize) => async dispatch => {
  dispatch({
    type: SELECT_PRINT_SIZE_FOR_CROP,
    payload: printSize
  })
  return Promise.resolve(printSize);
}

export const showTimeOutDialog = (visible) => async dispatch => {
  dispatch({
    type: TIMEOUT_DIALOG_OPEN,
    payload: visible
  })
}

// disabling Braze
//function initBraze(user) {
//  Braze.changeUser(user.id);
//  Braze.openSession();
//  onBrazeInit();
//
//  let u = Braze.getUser();
//  u.setEmail(user.email);
//  u.setFirstName(user.first_name);
//  u.setLastName(user.last_name);
//  u.setCustomUserAttribute('Portal.Account', user.account_id);
//  u.setCustomUserAttribute('Reservation.StartDate', user.start_date);
//  u.setCustomUserAttribute('Reservation.EndDate', user.end_date);
//}
